export enum MessagesEnum {
  required = `Ce champ est requis.`,
  wrongMailFormatError = `Le format de l'adresse email est incorrect.`,
  noEmptyMailError = `L'adresse email ne peut pas être vide.`,
  noEmptyPwdError = `Le mot de passe ne peut pas être vide.`,
  passwordNotSufficientlyComplex = `Le mot de passe n'est pas suffisament complexe.` +
    `\n Au moins 8 caractères sont requis dont une majuscule, une minuscule, un chiffre et un caractère spécial.`,
}
